module.exports = __webpack_public_path__ + "step5.c2ff6f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step5.png
// module id = P3RW
// module chunks = 0